let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9b0Br")).then(() => parcelRequire('XsSGE'));